import * as React from 'react';
import { Checkbox, FormControlLabel, CheckboxProps, Typography } from '@mui/material';
import styles from '../styles/Checkbox';
import { withStyles } from '@mui/styles';

interface Props extends CheckboxProps {
    classes?: any;
    label?: string;
    hidden?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    error?: boolean;
    labelStyle?: any;
}

class LrCheckbox extends React.Component<Props> {
    render() {
        const { classes, label, hidden, onChange, checked, error, labelStyle, ...rest } = this.props;

        if (hidden) return <></>;

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={onChange}
                        classes={{ root: error ? classes.error : classes.root, checked: classes.checked }}
                        {...rest}
                    />
                }
                label={label}
                classes={{ label: classes.label, root: classes.labelRoot }}
                sx={labelStyle}
            />
        );
    }
}

export default withStyles(styles)(LrCheckbox);
